/**
 * Dispatches all org-specific state resets to clear stale data on org switch.
 * Must be called AFTER Clerk setActive resolves to avoid stale RTK refetches.
 */

import { agentsApiSlice } from '@saaga/shared/store/agents-api.store'
import { apiSlice } from '@saaga/shared/store/api-base.store'
import { wsDisconnect } from '@saaga/shared/store/middleware/websocket.middleware'
import { clearBilling } from '@saaga/shared/store/slices/billing.slice'
import { resetBillingUi } from '@saaga/shared/store/slices/billing-ui.slice'
import { resetChat } from '@saaga/shared/store/slices/chat.slice'
import { resetDraftAgencyChat } from '@saaga/shared/store/slices/draft-agency-chat.slice'
import { closeSplitView } from '@saaga/shared/store/slices/split-view.slice'
import type { AppDispatch } from '@saaga/shared/store/store'

let lastResetOrgId: string | null = null

/**
 * Returns true (and consumes the flag) if an eager reset was already
 * dispatched for this org via the org switcher, so the reactive hook
 * can skip its redundant dispatch.
 */
export const wasAlreadyResetForOrg = (orgId: string): boolean => {
  if (lastResetOrgId === orgId) {
    lastResetOrgId = null
    return true
  }
  return false
}

export const dispatchOrganizationReset = (dispatch: AppDispatch, targetOrgId?: string): void => {
  if (targetOrgId) {
    lastResetOrgId = targetOrgId
  }

  dispatch(resetChat())
  dispatch(closeSplitView())
  dispatch(resetDraftAgencyChat())
  dispatch(resetBillingUi())
  dispatch(clearBilling())
  dispatch(apiSlice.util.resetApiState())
  dispatch(agentsApiSlice.util.resetApiState())
  dispatch(wsDisconnect())
}
